import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Drawer, Box } from '@mui/material';
import upImg from '../assets/up.png';
import '../css/isi.css';
import arrow from '../assets/arrow.png';
import cltLogo from '../assets/CSLB_logo.png';

const ISI = ({ customStylesClass }) => {
  const [open, setOpen] = useState(false);
  const clientConfig = useSelector((state) => state.data.clientConfig);

  const toggleDrawer = () => () => {
    setOpen((prev) => !prev);
  };

  return (
    <div className="isi-comp">
      <div className="isi-wrapper" style={{ display: open ? 'none' : '', cursor: 'pointer' }} onClick={toggleDrawer()}>
        Important Safety Information <img src={arrow} alt="arrow" />
      </div>
      <Drawer
        anchor="bottom"
        open={open}
        onClose={toggleDrawer()}
        PaperProps={{
          sx: {
            backgroundColor: 'transparent',
            padding: '0 10px',
            overflow: 'hidden'
          }
        }}
      >
        <Box>
          <Box
            sx={{
              backgroundColor: '#D9D9D9',
              width: '100%',
              maxWidth: '800px',
              margin: '0 auto',
              // padding: '20px',
              display: 'flex',
              height: '99vh',
              borderRadius: '20px',
              borderBottomLeftRadius: '0',
              borderBottomRightRadius: '0',
              overflow: 'hidden',
              alignItems: 'center',
              // height: '400px',
              flexDirection: 'column'
            }}
          >
            <div className="isi-title" onClick={toggleDrawer()} style={{ cursor: 'pointer' }}>
              Important Safety Information <img src={arrow} alt="arrow" style={{ transform: 'rotate(180deg)' }} />
            </div>

            <Box
              sx={{
                backgroundColor: '#FFFFFF',
                width: '95%'
              }}
            >
              <Box
                sx={{
                  padding: '16px',
                  overflowY: 'scroll',
                  maxHeight: '75vh',
                  borderRadius: '8px'
                }}
              >
                <div className="isi-body">
                  <p>
                    ANDEMBRY® (garadacimab-gxii) injection, for subcutaneous use, is an activated Factor XII (FXIIa)
                    inhibitor (monoclonal antibody) indicated for prophylaxis to prevent attacks of hereditary
                    angioedema (HAE) in adult and pediatric patients aged 12 years and older.
                  </p>
                  <p>
                    The most common adverse reactions in the pivotal trial (incidence ≥7%) were nasopharyngitis and
                    abdominal pain. In the pivotal trial and the open-label extension study, injection-site reactions
                    (eg, injection-site bruising, injection-site erythema, injection-site hematoma, injection-site
                    pruritus, injection-site urticaria) were reported in 23 (14%) patients.
                  </p>
                  <p>
                    No dedicated drug interaction studies have been conducted, nor is there data concerning the use of
                    ANDEMBRY in women who are pregnant or breastfeeding. The safety and efficacy of ANDEMBRY in patients
                    under 12 years of age have not been established.
                  </p>
                  <p>
                    <span style={{ textDecoration: 'underline' }}>Drug Interference with Laboratory Test: </span>
                    ANDEMBRY can prolong activated partial thromboplastin time (aPTT) due to an interaction of
                    garadacimab-gxii with the aPTT assay.
                  </p>
                  <p style={{ fontWeight: 'bold' }}>
                    Please see full{' '}
                    <a
                      href="https://labeling.cslbehring.com/PI/US/Andembry/EN/Andembry-Prescribing-Information.pdf"
                      target="_blank"
                      rel="noreferrer"
                    >
                      prescribing information
                    </a>{' '}
                    for ANDEMBRY.
                  </p>
                  <p>
                    To report SUSPECTED ADVERSE REACTIONS, contact the CSL Behring Pharmacovigilance Department at
                    <a className="no-break" href="tel:1-866-915-6958">
                      {' '}
                      1-866-915-6958
                    </a>{' '}
                    or FDA at{' '}
                    <a className="no-break" href="tel:1-800-FDA-1088">
                      1-800-FDA-1088
                    </a>{' '}
                    or{' '}
                    <a className="no-break" href="https://www.fda.gov/medwatch" target="_blank" rel="noreferrer">
                      www.fda.gov/medwatch
                    </a>
                    .
                  </p>
                </div>
              </Box>
            </Box>
            <div className="isi-footer">
              <div className={`slanted-div ${customStylesClass ? customStylesClass : ''} isi-branded`}>
                <div className="isi-wording-wrapper">
                  <div className="isi-wording-title">
                    <img src={cltLogo} alt="logo" />
                  </div>
                  <div className="isi-wording-body">
                    <p>
                      ANDEMBRY is manufactured by <span className="no-break">CSL Behring GmbH</span> <br /> and
                      distributed by <span className="no-break">CSL Behring LLC.</span>
                    </p>
                    <p>
                      ANDEMBRY<sup>®</sup> is a registered trademark of{' '}
                      <span className="no-break">CSL Behring GmbH.</span>
                    </p>

                    <p style={{ fontWeight: 'bold', marginTop: 5 }}>©2025 CSL Behring LLC.</p>
                    <p>1020 First Avenue, PO Box 61501, King of Prussia, PA 19406-0901 USA</p>
                    <p style={{ fontWeight: 'bold', textDecoration: 'underline', marginTop: 5 }}>
                      <a href="https://www.CSLBehring.com" target="_blank" rel="noreferrer">
                        www.CSLBehring.com {clientConfig.jobCode}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
              <img src={upImg} alt="up" className="arrow-up" onClick={toggleDrawer()} />
            </div>
          </Box>
        </Box>
      </Drawer>
    </div>
  );
};

export default ISI;
